export const DEFAULT_APP_NAME = 'Haby-Tontine Pro';

const resolvedAppName = (process.env.REACT_APP_APP_NAME || DEFAULT_APP_NAME).trim();

export const APP_NAME = resolvedAppName || DEFAULT_APP_NAME;
